import { Card, CardBody, CardHeader } from "@odingard/design-system";

export function Support() {
  return (
    <>
      <div className="page-head">
        <div>
          <h1>Support</h1>
          <p>We&apos;re here to help.</p>
        </div>
      </div>
      <div className="two-col">
        <Card>
          <CardHeader title="Contact support" />
          <CardBody>
            <p>
              Email <a href="mailto:support@odingard.com">support@odingard.com</a> or open a ticket from your account. Enterprise
              customers have a dedicated Slack channel and SLA.
            </p>
          </CardBody>
        </Card>
        <Card>
          <CardHeader title="Resources" />
          <CardBody>
            <div className="ods-stack">
              <a href="/resources">Documentation</a>
              <a href="/security">Security &amp; Trust</a>
              <a href="/contact">Talk to sales</a>
            </div>
          </CardBody>
        </Card>
      </div>
    </>
  );
}
